<sera-popup
    [(display)]="isVisible"
    [showRIComponent]="true"
    [color]="$activePartColor | async"
    [rzValue]="$activePartRzValue | async"
    (popupHidden)="closeForceCasePopupEvent.emit()"
    [headerText]="'PAGE.LOAD_CASE_TYPE.LBL' | translate"
    [allowOverflow]="true"
    [popupClass]="'force-case-cr7__popup'">
    <div
        class="force-case-cr7__container"
        [formGroup]="forceCasePopUpForm">
        <sera-tab-holder
            *ngIf="$tabHolderItems | async as tabHolderItems"
            [readOnly]="readonly"
            [isTabHolderButtons]="true"
            [activeItem]="getActiveTabItem(tabHolderItems)"
            [items]="tabHolderItems"
            (changeOfActiveItem)="this.onTabHolderChange($event)"></sera-tab-holder>
        <p
            class="force-case-cr7__tooltip"
            *ngIf="!this.isPullAndPush">
            {{ getToolTipBasedOnType() }}
        </p>
        <div class="force-case-cr7__dropdown-container">
            <sera-input-text
                [readOnly]="readonly"
                [inputStyle]="this.getInputStyleClassValidation('description')"
                [label]="('PAGE.ANALYSIS.CRITERION_DESCRIPTION.LBL' | translate) + ' *'"
                formControlName="description">
            </sera-input-text>
            <sera-input-number
                [readOnly]="readonly"
                [autoWidth]="true"
                [styleFloatLabel]="this.getInputStyleClassValidation('loadWeight')"
                [label]="('PAGE.MM_07.NIOSH_LOWEST_RWL_LOAD_KG.LBL' | translate) + ' *'"
                [numberPipeFractionDigits]="3"
                [maxFractionDigits]="99"
                formControlName="loadWeight"
                (inputNumberBlur)="this.updateActivePartAndRecalcOnLoadWeightChange()">
            </sera-input-number>
            <density-dropdown
                [readOnly]="readonly"
                [isFilterable]="false"
                [showClear]="false"
                [label]="('PAGE.MM_07.CONDITION_EXECUTION.LBL' | translate) + ' *'"
                formControlName="defExecutionConditionId"
                inputId="defExecutionConditionId"
                [options]="((this.isPullAndPush ? $pullAndPushExecutionConditionsOptions : $transferExecutionConditionsOptions) | async) || []"
                [styleClass]="this.getInputStyleClassValidation('defExecutionConditionId')"
                (selectionChanged)="this.updateActivePartAndRecalc()">
            </density-dropdown>
            <sera-input-number
                *ngIf="!this.isPullAndPush"
                [readOnly]="readonly || this.isProcessFrequencyFilled()"
                [autoWidth]="true"
                [styleFloatLabel]="this.getInputStyleClassValidation('frequencyPerShift')"
                [label]="this.getLabelBasedOnTabIndex()"
                [numberPipeFractionDigits]="readonly || this.isProcessFrequencyFilled() ? 0 : 3"
                [maxFractionDigits]="readonly || this.isProcessFrequencyFilled() ? 3 : 99"
                formControlName="frequencyPerShift"
                (inputNumberBlur)="this.updateActivePartAndRecalc()">
            </sera-input-number>
            <sera-input-number
                *ngIf="!this.isPullAndPush && (this.isProcessFrequencyFilled() || this.isTMOTKBTechnology())"
                [readOnly]="readonly"
                [autoWidth]="true"
                [inputStyleClass]="this.getInputStyleClassValidation('realFrequencyPerAnalysis')"
                [styleFloatLabel]="this.getInputStyleClassValidation('realFrequencyPerAnalysis')"
                [label]="this.getRealFrequencyPerAnalysisLabel() + ' *'"
                [numberPipeFractionDigits]="3"
                [maxFractionDigits]="99"
                formControlName="realFrequencyPerAnalysis"
                (inputNumberBlur)="this.updateActivePartAndRecalc()">
            </sera-input-number>
            <sera-input-number
                *ngIf="!this.isPullAndPush && this.isTMOTechnology()"
                [readOnly]="readonly"
                [autoWidth]="true"
                [styleFloatLabel]="this.getInputStyleClassValidation('divisor')"
                [label]="('PAGE.ANALYSIS.DIVISOR.LBL' | translate) + ' *'"
                [numberPipeFractionDigits]="3"
                [maxFractionDigits]="99"
                formControlName="divisor"
                (inputNumberBlur)="this.updateActivePartAndRecalc()">
            </sera-input-number>
            <density-dropdown
                *ngIf="this.isPullAndPush"
                [readOnly]="readonly"
                [isFilterable]="false"
                [showClear]="false"
                [label]="('PAGE.MM_07.POSITIONING_ACCURACY.LBL' | translate) + ' *'"
                formControlName="positioningPrecision"
                inputId="positioningPrecision"
                [styleClass]="this.getInputStyleClassValidation('positioningPrecision')"
                [options]="getPositioningPrecisionOptions()"
                (selectionChanged)="this.updateActivePartAndRecalc()">
            </density-dropdown>
            <density-dropdown
                *ngIf="this.isPullAndPush"
                [readOnly]="readonly"
                [isFilterable]="false"
                [showClear]="false"
                [label]="('PAGE.MM_07.MOVING_SPEED.LBL' | translate) + ' *'"
                formControlName="movementVelocity"
                inputId="movementVelocity"
                [styleClass]="this.getInputStyleClassValidation('movementVelocity')"
                [options]="getMovementVelocityOptions()"
                (selectionChanged)="this.updateActivePartAndRecalc()">
            </density-dropdown>
            <div
                [ngSwitch]="isPullAndPush"
                [ngClass]="!isPullAndPush ? 'checkbox-container' : 'checkbox-container checkbox-container--pull-push'">
                <sera-checkbox
                    *ngSwitchCase="false"
                    formControlName="oneHanded"
                    [readOnly]="readonly"
                    [inputId]="'oneHanded'"
                    [label]="'PAGE.MM_07.ONE_HANDED.LBL' | translate"
                    (stateChanged)="this.updateActivePartAndRecalc()">
                </sera-checkbox>
                <sera-checkbox
                    *ngSwitchCase="true"
                    formControlName="cartWithCasterWheels"
                    [readOnly]="readonly"
                    [inputId]="'cartWithCasterWheels'"
                    [label]="'PAGE.MM_07.CEWCW.LBL' | translate"
                    (stateChanged)="this.updateActivePartAndRecalc()">
                </sera-checkbox>
            </div>
        </div>
        <sera-horizontal-line *ngIf="isPullAndPush"></sera-horizontal-line>
        <div
            *ngIf="isPullAndPush"
            class="force-case-cr7__pull_push_extra_container">
            <div class="force-case-cr7__pull_push_extra_container__tab_holder">
                <sera-tab-holder
                    [styleClass]="'small-tab-holder'"
                    [readOnly]="readonly"
                    [isTabHolderButtons]="true"
                    [activeItem]="pullPushActiveMenuItem"
                    [items]="pullPushTabHolderItems"
                    (changeOfActiveItem)="onPullPushMenuItemChange($event)"></sera-tab-holder>
            </div>
            <div class="force-case-cr7__pull_push_extra_container__inputs">
                <sera-input-number
                    *ngIf="pullPushActiveMenuItem.id === 'distanceShort'"
                    [readOnly]="readonly || this.isProcessFrequencyFilled()"
                    [autoWidth]="true"
                    [label]="('PAGE.MM_07.FREQUENCY_SHORT_PER_SHIFT.LBL' | translate) + (!this.isProcessFrequencyFilled() ? ' *' : '')"
                    [styleFloatLabel]="this.getInputStyleClassValidation('distanceShort')"
                    class="force-case-cr7__pull_push_extra_container__inputs--width"
                    [numberPipeFractionDigits]="readonly || this.isProcessFrequencyFilled() ? 0 : 3"
                    [maxFractionDigits]="readonly || this.isProcessFrequencyFilled() ? 3 : 99"
                    formControlName="distanceShort"
                    (inputNumberBlur)="this.updateActivePartAndRecalc()">
                </sera-input-number>
                <sera-input-number
                    class="force-case-cr7__pull_push_extra_container__inputs--width"
                    *ngIf="pullPushActiveMenuItem.id === 'distanceShort' && (this.isProcessFrequencyFilled() || this.isTMOTKBTechnology())"
                    [readOnly]="readonly"
                    [autoWidth]="true"
                    [label]="('PAGE.MM_07.REAL_DISTANCE_SHORT.LBL' | translate) + ' *'"
                    [inputStyleClass]="this.getInputStyleClassValidation('realDistanceShort')"
                    [styleFloatLabel]="this.getInputStyleClassValidation('realDistanceShort')"
                    [numberPipeFractionDigits]="3"
                    [maxFractionDigits]="99"
                    formControlName="realDistanceShort"
                    (inputNumberBlur)="this.updateActivePartAndRecalc()">
                </sera-input-number>
                <sera-input-number
                    class="force-case-cr7__pull_push_extra_container__inputs--width"
                    *ngIf="pullPushActiveMenuItem.id === 'distanceLong'"
                    [readOnly]="readonly || this.isProcessFrequencyFilled()"
                    [autoWidth]="true"
                    [label]="('PAGE.MM_07.DISTANCE_LONG.LBL' | translate) + (!this.isProcessFrequencyFilled() ? ' *' : '')"
                    [styleFloatLabel]="this.getInputStyleClassValidation('distanceLong')"
                    [numberPipeFractionDigits]="readonly || this.isProcessFrequencyFilled() ? 0 : 3"
                    [maxFractionDigits]="readonly || this.isProcessFrequencyFilled() ? 3 : 99"
                    formControlName="distanceLong"
                    (inputNumberBlur)="this.updateActivePartAndRecalc()">
                </sera-input-number>
                <sera-input-number
                    class="force-case-cr7__pull_push_extra_container__inputs--width"
                    *ngIf="pullPushActiveMenuItem.id === 'distanceLong' && (this.isProcessFrequencyFilled() || this.isTMOTKBTechnology())"
                    [readOnly]="readonly"
                    [autoWidth]="true"
                    [label]="('PAGE.MM_07.REAL_DISTANCE_LONG.LBL' | translate) + ' *'"
                    [inputStyleClass]="this.getInputStyleClassValidation('realDistanceLong')"
                    [styleFloatLabel]="this.getInputStyleClassValidation('realDistanceLong')"
                    [numberPipeFractionDigits]="3"
                    [maxFractionDigits]="99"
                    formControlName="realDistanceLong"
                    (inputNumberBlur)="this.updateActivePartAndRecalc()">
                </sera-input-number>
                <sera-input-number
                    class="force-case-cr7__pull_push_extra_container__inputs--width"
                    *ngIf="this.isTMOTechnology()"
                    [readOnly]="readonly"
                    [autoWidth]="true"
                    [styleFloatLabel]="this.getInputStyleClassValidation('divisor')"
                    [label]="('PAGE.ANALYSIS.DIVISOR.LBL' | translate) + ' *'"
                    [numberPipeFractionDigits]="3"
                    [maxFractionDigits]="99"
                    formControlName="divisor"
                    (inputNumberBlur)="this.updateActivePartAndRecalc()">
                </sera-input-number>
            </div>
        </div>
        <sera-horizontal-line></sera-horizontal-line>
        <cr7-force-case-images
            [postureItems]="isPullAndPush ? pullAndPushPostures : transferPostures"
            [isRequired]="true"
            [readOnly]="readonly"
            [isInvalid]="isBodyPostureSumInvalid()"
            [isToShowBodyPostureToggle]="this.currentSelectedTabIndex === 0"
            [isToShowInputForBodyPosture]="this.forceCasePopUpForm.value.isPercentageToggle"
            (bodyPostureClick)="handleImageClick($event)"
            (bodyPostureToggleChange)="handlePercentageToggle($event)"
            (bodyPostureBlur)="handleInputBlur($event)">
        </cr7-force-case-images>
        <div class="force-case-cr7__comment_container">
            <sera-input-text-area
                class="force-case-cr7__comment_container__text_area"
                formControlName="commentPart"
                [readOnly]="readonly"
                [label]="'PAGE.MM_03.COMMENT' | translate"
                (inputChanged)="handleCommentInputChanges($event)">
            </sera-input-text-area>
        </div>
        <div class="sera-popup-footer">
            <ds-button
                *ngIf="!readonly"
                [variant]="'ghost'"
                (click)="closeForceCasePopupEvent.emit()"
                (keydown.enter)="closeForceCasePopupEvent.emit()">
                {{ 'PAGE.GENERAL.CANCEL.BT' | translate }}
            </ds-button>
            <ds-button
                *ngIf="!readonly"
                ds-loading
                [variant]="'primary'"
                [isLoading]="($selectIsWaitingForRecalc | async)!"
                (click)="onAddButton()"
                (keydown.enter)="onAddButton()">
                {{ this.isNewForceCase ? ('PAGE.COMMON_ADD.LBL' | translate) : ('PAGE.GENERAL.SAVE.BT' | translate) }}
            </ds-button>
            <ds-button
                *ngIf="readonly"
                [variant]="'ghost'"
                (click)="closeForceCasePopupEvent.emit()"
                (keydown.enter)="closeForceCasePopupEvent.emit()">
                {{ 'PAGE.GENERAL.CLOSE.BT' | translate }}
            </ds-button>
        </div>
    </div>
</sera-popup>
<ng-container *ngIf="$pullAndPushDefId | async"></ng-container>
<ng-container *ngIf="$postureItems | async"></ng-container>
<ng-container *ngIf="$analysisTechnology | async"></ng-container>
<ng-container *ngIf="$analysisProcessFrequency | async"></ng-container>
<ng-container *ngIf="$activePart | async"></ng-container>
